import { render, staticRenderFns } from "./AppList.vue?vue&type=template&id=6f4fe3a9&"
import script from "./AppList.vue?vue&type=script&lang=ts&"
export * from "./AppList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports